/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodSearchCriteriaContract} from '../../../api/contracts/period/period-search-criteria.contract';
import {PeriodSearchCriteriaModel} from './period-search-criteria.model';
import {CriterionBaseContract} from '../../../api/contracts/criterion-base.contract';
import {CriterionBaseModel} from '../../criterion-base/criterion-base.model';
import {BundleCriterionBaseContract} from '../../../api/contracts/bundle/bundle-criterion-base.contract';
import {DateCriterionMapper} from '../../date-criterion/date-criterion.mapper';
import {QuantityCriterionMapper} from '../../quantity-criterion/quantity-criterion.mapper';

export class PeriodSearchCriteriaMapper {

    static fromPeriodSearchCriteriaContract(input: PeriodSearchCriteriaContract): PeriodSearchCriteriaModel {
        let model: PeriodSearchCriteriaModel;

        if (input != null) {
            model = {
                periodCode: input.code,
                bundleTypeCode: input.bundleTypeCode,
                customerCode: input.customerCode,
                settlementCode: input?.settlementCode,
                complaintCode: input?.complaintCode,
                bundleNumber: input?.bundleNumber,
                bundleCriteria: this.toBundleCriteriaModel(input?.bundleCriteria),
                bundlePositionCriteria: this.toBundleCriteriaModel(input?.bundlePositionCriteria),
                periodDateCriteria: DateCriterionMapper.fromDateCriterionContract(input?.periodDateCriteria),
                periodTotalAmount: QuantityCriterionMapper.fromQuantityCriterionContract(input?.periodTotalAmount),
                settlementTotalAmount: QuantityCriterionMapper.fromQuantityCriterionContract(input?.settlementTotalAmount),
                periodTypeCodes: input?.periodTypeCodes,
                bundleStatusCodes: input?.bundleStatusCodes
            };
        }
        return model;
    }

    static toPeriodSearchCriteriaContract(input: PeriodSearchCriteriaModel): PeriodSearchCriteriaContract {
        let model: PeriodSearchCriteriaContract;

        if (input != null) {
            model = {
                code: input.periodCode,
                bundleTypeCode: input.bundleTypeCode,
                customerCode: input.customerCode,
                settlementCode: input?.settlementCode,
                complaintCode: input?.complaintCode,
                bundleNumber: input?.bundleNumber,
                bundleCriteria: this.toBundleCriteriaContract(input?.bundleCriteria),
                bundlePositionCriteria: this.toBundleCriteriaContract(input?.bundlePositionCriteria),
                periodDateCriteria: DateCriterionMapper.toDateCriterionContract(input?.periodDateCriteria),
                periodTotalAmount: QuantityCriterionMapper.toQuantityCriterionContract(input?.periodTotalAmount),
                settlementTotalAmount: QuantityCriterionMapper.toQuantityCriterionContract(input?.settlementTotalAmount),
                periodTypeCodes: input?.periodTypeCodes,
                bundleStatusCodes: input?.bundleStatusCodes
            };
        }
        return model;
    }

    static toBundleCriteriaContract(input: CriterionBaseModel[]): BundleCriterionBaseContract[]{
        const model: BundleCriterionBaseContract[] = [];

        if (input != null) {
            input.map((value) => {
                model.push(value);
            });
            return model;
        }
    }

    static toBundleCriteriaModel(input: CriterionBaseContract[]): CriterionBaseModel[] {
        const model: CriterionBaseModel[] = [];

        if (input != null) {
            input.map((result) => {
                model.push(result);
            });
            return model;
        }
    }
}
